import { rpcClient } from "@/api/WebsocketClient"
import { reactive } from '@vue/reactivity'
import Project from '@/model/directory/Project';


export default class GeneratedProjectStore {

    state: {
        projects: Map<string, Project>,
        calls: Map<string, string | string[]>
    }
    timer: number | null = null

    constructor() {
        let projects: Map<string, Project> | null = null
        try {
            const persistedState = localStorage.getItem('ProjectStore')
            if (persistedState) {
                projects = new Map(JSON.parse(persistedState))
            }
        } catch (ignore) {}
        this.state = reactive({
            projects: projects || new Map<string, Project>(),
            calls: new Map<string, string | string[]>()
        })
        this.init()
    }

    init() {
        window.setTimeout(() => {
            if (rpcClient) {
                rpcClient.stores.push(this)
            } else {
                this.init()
            }
        }, 1)
    }

    persistState() {
        if (this.timer === null) {
            setTimeout(() => {
                localStorage.setItem('ProjectStore', JSON.stringify(Array.from(this.state.projects)))
                this.timer = null
            }, 1000)
        }
    }

    clearState() {
        if (this.timer) clearTimeout(this.timer)
        if (this.state?.projects) this.state.projects.clear()
        if (this.state?.calls) this.state.calls.clear()
        localStorage.removeItem('ProjectStore')
    }

    addOrReplaceProject(newProject: Project, persist: boolean = true): true | undefined {
        if (newProject.id) {
            this.state.projects.set(newProject.id, newProject)
            
            if (persist) {
                this.persistState()
            } else {
                return true
            }
        }
    }
    
    addOrReplaceProjects(newProjects: Project[]) {
        let persist = false
        for (const newProject of newProjects) {
            const changed = !!this.addOrReplaceProject(newProject, false)
            persist = persist || changed
        }
        if (persist) {
            this.persistState()
        }
    }

    replaceProjects(projects: Project[]) {
        const newProjects = new Map<string, Project>()
        for (const newProject of projects) {
            if (newProject.id) {
                newProjects.set(newProject.id, newProject)
                
            }
        }
        this.state.projects = newProjects
        this.persistState()
    }

    removeProject(id: string | undefined | null, persist: boolean = true): true | undefined {
        if (id !== undefined && id !== null) {
            if (this.state.projects.delete(id)) {
                if (persist) {
                    this.persistState()
                } else {
                    return true
                }
            }
        }
    }

    removeProjects(ids: (string | null)[] | undefined | null) {
        let persist = false
        if (ids !== undefined && ids !== null) {
            for (const id of ids) {
                const changed = !!this.removeProject(id, false)
                persist = persist || changed
            }
        }
        if (persist) {
            this.persistState()
        }
    }
}